import { useState, useContext, useEffect, useRef } from 'react'
import { useLocation, Link, } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { MdOutlineDelete } from "react-icons/md";

import NumberCart from "./product/Number";
import { Img, Tasks } from "./Elements";
import { AppContext } from "../../Context";
import { totalPrice, priceFormat } from "../inc/Fetch";

import './css/cart.css'

export default function CartList({v, type}) {

    const { t } = useTranslation();
    let ref = useRef(false);
    const location = useLocation();

    const {cartData, siteData, user} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
	const [cart, setcart] = cartData;
    const [userinfo, setuserinfo] = user;

    const [values, setvalues] = useState(0);

    function reduseNumber(val) {
        
        let arr = [];
        setcart(p => {

            p?.map(v2 => {
                if (v2?._id == v?._id) {
                    v2.num = val;
                }
                arr.push(v2);
            });

            return arr
        });

    }

    function deleteCart() {
        let conf = window.confirm(t("cart_remove_text"));
        if (!conf) {
            return false;
        }

        if (cart?.length <= 1) {
            localStorage.removeItem("cart");
			setcart([]);
        }

        setcart(p => p?.filter(r => r?._id != v?._id));
    }


    useEffect(() => {

        if (values) {
            reduseNumber(values);
        }

    }, [values]);
    
    let total = totalPrice(v);
    let linkData = {pathname: "/cartInfo/" };
    
    
    return (
        <div className='cartListBox'>
            <Link to={linkData} state={{ previousLocation: { pathname:"/"}, data:v }} className='cartMoreOpt'>
                <Img src={`img/250x200/${v?.img[0]}`}/>
            </Link>
            <Link to={linkData} state={{ previousLocation: { pathname:"/" }, data:v }} className='cartListBoxInfo'>
                <h4>{v?.title}</h4>
                
                {userinfo?.settings?.discount ? 
                    <>
                        {siteInfo?.settings?.show_prices?.val == 1 || (siteInfo?.settings?.show_prices?.val == 0 && userinfo?._id) ? <b className='price'>{priceFormat(total - total * (userinfo?.settings?.discount / 100))} <span>{global?.currency}</span> </b>: false}
                        {siteInfo?.settings?.show_prices?.val == 1 || (siteInfo?.settings?.show_prices?.val == 0 && userinfo?._id) ? <b style={{textDecoration:"line-through", color:"#999", fontSize:11}} className='price'>{priceFormat(total)} <span>{global?.currency}</span> </b>: false}
                    </>
                :
                    <>
                        {siteInfo?.settings?.show_prices?.val == 1 || (siteInfo?.settings?.show_prices?.val == 0 && userinfo?._id) ? <b className='price'>{priceFormat(total)} <span>{global?.currency}</span> </b>: false}
                    </>
                }
            </Link>
            {type != "info" ?
            <>
                <NumberCart onChange={(v) => setvalues(v?.val)} qnt={v?.qnt} value={values || v?.num || 1}/>
                <a onClick={deleteCart} className='cartListBoxDel'><MdOutlineDelete /></a>
            </>: false}
        </div>
    )
}
